import React from 'react';
import { GoCheckCircle } from 'react-icons/go';
import { StyledAgentCreated } from './AgentSuccessModal.style';

const AgentSuccessModal = ({
  desc = 'Congratulations, your agent is active successfully, you can start using it.',
}) => {
  return (
    <StyledAgentCreated>
      <div className="holder">
        <div className="img-box">
          <GoCheckCircle className="icon" />
        </div>
        <p>{desc}</p>
      </div>
    </StyledAgentCreated>
  );
};

export default AgentSuccessModal;
